import type { Importer } from '@feathr/blackbox';
import { getImportedRowCount } from '@feathr/extender/components/ImportRunLines/ImportRunLines.utils';

/**
 * Whether a complete import has counts to show. Imports that finished before the API recorded
 * counts report all zeros.
 */
export function hasRecordedCounts(importer: Importer): boolean {
  return (
    importer.get('state') === 'complete' &&
    getImportedRowCount(importer) + importer.get('skipped', 0) > 0
  );
}
